<template>
  <Icon
    name="export"
    :width="18"
    :height="18"
  >
    <path d="M17.5 2.14855L16.1 0.488218C15.9714 0.325299 15.8039 0.195613 15.6122 0.110488C15.4204 0.0253634 15.2102 -0.01261 15 -0.000114886H3C2.77659 -0.00198487 2.55511 0.0403149 2.34888 0.124238C2.14266 0.208161 1.95595 0.331972 1.8 0.488218L0.5 2.14855C0.190714 2.50414 0.0143991 2.95186 0 3.41822L0 15.6266C0.00158273 16.1441 0.212805 16.6401 0.587535 17.0061C0.962265 17.372 1.47005 17.5783 2 17.5799H16C16.5299 17.5783 17.0377 17.372 17.4125 17.0061C17.7872 16.6401 17.9984 16.1441 18 15.6266V3.41822C17.9856 2.95186 17.8093 2.50414 17.5 2.14855ZM9 14.1616L3.5 8.78989H7V6.83655H11V8.78989H14.5L9 14.1616ZM2.1 1.95322L2.9 0.976552H14.9L15.8 1.95322H2.1Z" />
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Export',
  components: { Icon }
};
</script>
